import React, {useEffect, useState} from 'react';
import {ReactComponent as EditIcon} from '../../../../../../assets/main/groups/main-top/edit.svg';
import {ReactComponent as CommentaryIcon} from '../../../../../../assets/main/groups/online/commentary.svg';
import {ReactComponent as LetterIcon} from '../../../../../../assets/main/groups/online/letter.svg';
import {ReactComponent as CloseIcon} from '../../../../../../assets/main/groups/online/cross.svg';
import {DetailsNote} from "./details-note/Details-note";
import {useAppDispatch, useAppSelector} from "common/hook";
import {setFormReviewAC, setProblemsClassAC} from "app/popups-reducer";
import {ROLE_DEMO_STUDENT, ROLE_HR, ROLE_STUDENT, ROLE_TEACHER} from "entities/constants/constants";
import {Link, useLocation, useParams} from "react-router-dom";
import {NothingYetMessage} from "../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {Preloader} from "components/layout/preloader/Preloader";
import {fetchLessonsId} from "features/model/service/groups/lessons/fetchLessonsId";

import {setMeetingURL} from "features/model/slice/groups/botton-lesson/joinMeetingSlice";
import {message} from "antd";
import {singUpMeeting} from "features/model/service/lessons/lessons-demo/sign-up-meeting/signUpMeeting";
import {singOffMeeting} from "features/model/service/lessons/lessons-demo/sing-off-meeting/singOffMeeting";
import {fetchProblems} from "features/model/service/groups/groups-lessons/fetch-problems/fetchProblems";
import {
    DetailsPopup
} from "components/pages/groups/online-communication/tabs-content/details/details-popup/DetailsPopup";
import {startLesson} from "features/model/service/lessons/lessons-button/start-lesson/startLesson";
import {startMeeting} from "features/model/service/lessons/lessons-button/start-meeting/startMeeting";
import {fetchLessonsDemo} from "features/model/service/lessons/lessons-demo/fetchLessonsDemo";
import {joinMeeting} from "features/model/service/lessons/lessons-button/join-meeting/joinMeeting";
import {
    LessonActionsTeacher
} from "components/pages/groups/online-communication/tabs-content/details/lesson-actions-teacher/LessonActionsTeacher";



export const Details = () => {
    const dispatch = useAppDispatch()
    const {lessonsId} = useParams();
    const isProblemsClass = useAppSelector((state) => state.popups.isProblemsClass);
    const roleType = useAppSelector((state) => state.role.roleType);
    const lessonsState = useAppSelector((state) => state.lessons);
    const meetingURLData = useAppSelector(state => state.joinMeeting.meetingURL)
    const [isLoadingAction, setIsLoadingAction] = useState(false);
    const successMessages = useAppSelector((state) => state.reviewLesson.successMessage);
    const errorMessages = useAppSelector((state) => state.reviewLesson.error);
    const {items, isLoading, error} = lessonsState





    useEffect(() => {
        dispatch(fetchLessonsId(lessonsId));
    }, [dispatch, lessonsId]);


    useEffect(() => {
        if (roleType === ROLE_TEACHER || roleType === ROLE_HR) {
            dispatch(fetchProblems({lessonsId: lessonsId}));
        }
    }, [dispatch, lessonsId]);


    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const reviewParam = searchParams.get("review");

    const [isLoadingMeeting, setIsLoadingMeeting] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);

    const responseSubscribedLessonId = useAppSelector((state) => state.lessonsDemo.subscribedLessonId);


    useEffect(() => {
        if (roleType === ROLE_STUDENT || roleType === ROLE_DEMO_STUDENT) {
            if (items[0]?.startingSoon) {
                const intervalId = setInterval(() => {
                    dispatch(fetchLessonsId(lessonsId));
                }, 10000);

                return () => clearInterval(intervalId);
            }
        }
    }, [dispatch, items, lessonsId, roleType]);


    useEffect(() => {
        setIsSubscribed(responseSubscribedLessonId !== null);
    }, [responseSubscribedLessonId]);


    const joinSingUpMeeting = async (lessonsId: any) => {
        setIsLoadingMeeting(true);
        if (lessonsId) {
            await dispatch(singUpMeeting(lessonsId));
        }
        await dispatch(fetchLessonsId(lessonsId));
        setIsLoadingMeeting(false);
    };

    const singOffMeetingHandler = async (lessonsId: any) => {
        setIsLoadingMeeting(true);
        if (lessonsId) {
            await dispatch(singOffMeeting(lessonsId));
        }
        await dispatch(fetchLessonsId(lessonsId));
        setIsLoadingMeeting(false);
    };


    const showNotification = (messageText: string | null, type: 'success' | 'error') => {
        if (messageText) {
            message[type](messageText);
        }
    };


    useEffect(() => {
        if (reviewParam && (roleType === ROLE_STUDENT || roleType === ROLE_DEMO_STUDENT)) {
            dispatch(setFormReviewAC(true));
            showNotification(successMessages, 'success');
            showNotification(errorMessages, 'error');
        }
    }, [reviewParam, roleType, successMessages, errorMessages]);


    const onClickHandler = () => {
        dispatch(setProblemsClassAC(!isProblemsClass))
    }


    const startLessonHandler = async () => {
        if (lessonsId) {
            setIsLoadingAction(true)
            await dispatch(startLesson(lessonsId));
            await dispatch(fetchLessonsId(lessonsId));
            setIsLoadingAction(false)
        }
    }

    const startMeetingHandler = async (lessonsId: string | undefined) => {
        if (lessonsId) {
            setIsLoadingAction(true)
            await dispatch(startMeeting(lessonsId));
            await dispatch(fetchLessonsId(lessonsId));
            setIsLoadingAction(false)
        }
    };
    const joinMeetingHandler = async (lessonsId: string | undefined | number) => {
        if (lessonsId) {
            setIsLoadingAction(true)
            await dispatch(joinMeeting(lessonsId));
            dispatch(fetchLessonsDemo({}));
            setIsLoadingAction(false)
        }
    };


    useEffect(() => {
        if (meetingURLData) {
            window.open(meetingURLData, '_blank');
            dispatch(setMeetingURL(""))
        }
    }, [meetingURLData]);


    function getStatusClassName(status: string) {
        switch (status) {
            case 'new':
                return 'group-item';
            case 'inProgress':
                return 'in-progress';
            case 'finished':
                return 'completed';
            default:
                return '';
        }
    }


    return (
        <div className="tabs-content">
            {isLoading ? (
                <Preloader/>
            ) : (
                items && items.length > 0 ? (
                    items.map((lesson) => {
                        const isSelectedLesson = lesson.id === responseSubscribedLessonId;
                        return (
                            <div className="tab" key={lesson.id}>
                                <div className="details-data-box">
                                    <div className="col">
                                        <p className="col-title">Статус</p>
                                        <p className={`status-item ${getStatusClassName(lesson.status)}`}>
                                            {lesson.status === 'new' ? 'Новое' : lesson.status === 'inProgress' ? 'В процессе' : lesson.status === 'finished' ? "Завершен" : null}
                                        </p>
                                    </div>
                                    <div className="col">
                                        <p className="col-title">Дата и время занятия</p>
                                        {lesson.dateTime}
                                    </div>
                                    {roleType !== ROLE_DEMO_STUDENT && (
                                        <div className="col">
                                            <p className="col-title">Группа</p>
                                            <Link to={`/groups/${lesson.group.id}`}>{lesson.group.title}</Link>
                                        </div>
                                    )}

                                    {roleType === ROLE_DEMO_STUDENT && lesson?.teacher && (
                                        <div className="col action-col">
                                            <p className="col-title">Учитель</p>
                                            {lesson.teacher}
                                        </div>
                                    )}


                                    {roleType === ROLE_TEACHER && (
                                        <>
                                            {lesson.status === 'inProgress' && <DetailsPopup lesson={lesson} />}
                                            <LessonActionsTeacher
                                                lesson={lesson}
                                                startLessonHandler={startLessonHandler}
                                                joinMeetingHandler={joinMeetingHandler}
                                                startMeetingHandler={startMeetingHandler}
                                                isLoadingAction={isLoadingAction}
                                                lessonsId={lessonsId}
                                            />
                                        </>
                                    )}



                                    {roleType === ROLE_DEMO_STUDENT && (
                                        <>
                                            {responseSubscribedLessonId === lesson.id && lesson.status === 'new' ? (
                                                <div className='enter-class'>
                                                    <button
                                                        style={{width: '190px'}}
                                                        className="btn"
                                                        disabled={true}
                                                    >
                                                        <a style={{boxShadow: 'none'}}>
                                                            <span>{isLoadingAction ? 'Загрузка...' : 'Ожидайте начала занятия'}</span>
                                                        </a>
                                                    </button>
                                                    <button
                                                        onClick={() => singOffMeetingHandler(lesson.id)}
                                                        className={`btn secondary ${isLoadingMeeting ? ' disabled' : ''}`}
                                                        disabled={isLoadingMeeting}
                                                    >
                                                        <span>{isLoadingMeeting ? 'Загрузка...' : 'Отменить'}</span>
                                                    </button>
                                                </div>
                                            ) : lesson.status === 'new' ? (
                                                <button
                                                    onClick={() => joinSingUpMeeting(lesson.id)}
                                                    className={`btn ${isLoadingMeeting ? ' disabled' : ''}`}
                                                    disabled={isLoadingMeeting || isSubscribed}
                                                >
                                                    <span>{isLoadingMeeting ? 'Загрузка...' : 'Записаться'}</span>
                                                </button>
                                            ) : lesson.status === 'inProgress' && (
                                                <div style={{alignItems: 'right'}} className="col action-col">
                                                    <button

                                                        className="btn"
                                                        onClick={() => joinMeetingHandler(lessonsId)}
                                                        disabled={isLoadingAction || !lesson.meetingIsRunning}
                                                    >
                                                        <a style={{boxShadow: 'none'}}>
                                                            <span>{isLoadingAction ? 'Загрузка...' : 'Войти в занятие'}</span>
                                                        </a>
                                                    </button>
                                                </div>
                                            )}
                                        </>
                                    )}


                                    {roleType === ROLE_STUDENT && (
                                        <>
                                            {responseSubscribedLessonId === lesson.id && lesson.status === 'new' ? (
                                                <div className='enter-class'>
                                                    <button
                                                        style={{width: '190px'}}
                                                        className="btn"
                                                        disabled={true}
                                                    >
                                                        <a style={{boxShadow: 'none'}}>
                                                            <span>{isLoadingAction ? 'Загрузка...' : 'Войти в занятие'}</span>
                                                        </a>
                                                    </button>

                                                    <button
                                                        onClick={() => singOffMeetingHandler(lesson.id)}
                                                        className={`btn secondary ${isLoadingMeeting ? ' disabled' : ''}`}
                                                        disabled={isLoadingMeeting}
                                                    >
                                                        <span>{isLoadingMeeting ? 'Загрузка...' : 'Отменить'}</span>
                                                    </button>
                                                </div>
                                            ) : lesson.status === 'new' ? (
                                                <button
                                                    onClick={() => joinSingUpMeeting(lesson.id)}
                                                    className={`btn ${isLoadingMeeting ? ' disabled' : ''}`}
                                                    disabled={true}
                                                >
                                                    <span>Ожидайте начала занятия</span>
                                                </button>
                                            ) : lesson.status === 'inProgress' && (
                                                <div style={{alignItems: 'right'}} className="col action-col">
                                                    <button
                                                        className="btn"
                                                        onClick={() => joinMeetingHandler(lessonsId)}
                                                        disabled={isLoadingAction || !lesson.meetingIsRunning}

                                                    >
                                                        <a style={{boxShadow: 'none'}}>
                                                            <span>{isLoadingAction ? 'Загрузка...' : 'Войти в занятие'}</span>
                                                        </a>
                                                    </button>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>


                                <div className="info-cards-box masonry-view">
                                    <div className="info-card large">
                                        <div className="info-card-hdr">
                                            <div className="title-box">
                                                <p className="info-card-title h6">Описание занятия</p>
                                            </div>
                                        </div>
                                        {lesson.description ? (
                                            <div className="info-card-content min-height">
                                                <p>{lesson.description}</p>
                                            </div>
                                        ) : (
                                            <div className="info-card-content">
                                                <NothingYetMessage/>
                                            </div>
                                        )}

                                    </div>
                                    <div className="info-card">
                                        <div className="info-card-hdr">
                                            <div className="title-box">
                                                <p className="info-card-title h6">Прикрепленные файлы</p>
                                            </div>
                                        </div>
                                        <div className="info-card-content">
                                            <ul className="attached-files-list">
                                                {lesson.files.length > 0 ? (
                                                    lesson.files.map((file, index) => (
                                                        <li key={index}>
                                                            <div className="file-name">
                                                                <a href={file.path} target="_blank"
                                                                   rel="noopener noreferrer">
                                                                    {file.fileName}
                                                                </a>
                                                            </div>
                                                            <span className="file-size">{file.fileSize}</span>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <NothingYetMessage/>
                                                )}
                                            </ul>
                                        </div>
                                    </div>

                                    <DetailsNote lesson={lesson}/>
                                    {(roleType === ROLE_TEACHER || roleType === ROLE_HR) && (
                                        <>
                                            <div className="info-card large problems-view">
                                                <div className="info-card-hdr">
                                                    <div className="title-box">
                                                        <p className="info-card-title h6">Отмеченные проблемы</p>
                                                    </div>
                                                    {roleType === ROLE_TEACHER && (
                                                        <span className="small-edit-btn pointer-elem"
                                                              onClick={onClickHandler}>
                                                            <EditIcon/>
                                                        </span>
                                                    )}
                                                </div>
                                                {lesson.problems ? (
                                                    <div className="info-card-content">
                                                        <div className="reported-issues">
                                                            {lesson.problems.absenceOfStudents && (
                                                                <div className="issue-item">
                                                                    <p className="p-icon">
                                                                        Отсутствие студента{' '}
                                                                        <span className="icon">
                                                                        <CloseIcon/>
                                                                    </span>
                                                                    </p>
                                                                    <div className="students-number">
                                                                        {lesson.problems.users.items.map((user, index) => (
                                                                            <div key={index} className="avatar">
                                                                                <img src={user.avatar} alt="avatar"/>
                                                                            </div>
                                                                        ))}
                                                                        <span
                                                                            className="num">{lesson.problems.users.count}</span>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {lesson.problems.technicalProblems && (
                                                                <div className="issue-item">
                                                                    <p className="p-icon">
                                                                        Технические проблемы{' '}
                                                                        <span className="icon">
                                                                        <CloseIcon/>
                                                                    </span>
                                                                    </p>
                                                                </div>
                                                            )}
                                                            {lesson.problems.lateCancellation && (
                                                                <div className="issue-item">
                                                                    <p className="p-icon">
                                                                        Поздняя отмена{' '}
                                                                        <span className="icon">
                                                                        <CloseIcon/>
                                                                    </span>
                                                                    </p>
                                                                </div>
                                                            )}

                                                            {lesson.problems.other && (
                                                                <div className="issue-item full-width">
                                                                    <p className="p-icon">
                                                                        {lesson.problems.comment}
                                                                        <span className="icon">
                                                                        <CommentaryIcon/>
                                                                    </span>
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="info-card-content">
                                                        <div className="info-message-box">
                                                            <p className="p-icon">
                                                                Нет отмеченных проблем{' '}
                                                                <span className="icon">
                                                                <LetterIcon/>
                                                            </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        )
                            ;
                    })
                ) : (
                    <NothingYetMessage/>
                )
            )}
        </div>
    );
};
